import { render, staticRenderFns } from "./ServicesReservationAddedServiceInfo.vue?vue&type=template&id=39da90e6&scoped=true&"
import script from "./ServicesReservationAddedServiceInfo.vue?vue&type=script&lang=js&"
export * from "./ServicesReservationAddedServiceInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39da90e6",
  null
  
)

export default component.exports